module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-upload-23907a36.svg";